module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/ruth-goodwin-ee562a3d42840c3d6c18f5c61aae3970.jpg";